// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o7KKB","left":"styles_left__1Q5-_","desktopActions":"styles_desktopActions__2on4T","title":"styles_title__10ksJ"};